import { render, staticRenderFns } from "./ktpInfo.vue?vue&type=template&id=15e5ea64"
import script from "./ktpInfo.vue?vue&type=script&lang=ts"
export * from "./ktpInfo.vue?vue&type=script&lang=ts"
import style0 from "./ktpInfo.vue?vue&type=style&index=0&id=15e5ea64&prod&lang=scss"
import style1 from "./ktpInfo.vue?vue&type=style&index=1&id=15e5ea64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports